<template>
  <main>
    <div class="page-container">
      <h2 class="condena-text-center">Me hayo eternamente condenado</h2>
      <button class="btn-biblia" id="biblia-btn" @click="showBibliaSection">La Biblia</button>
      <div class="condena-card">
      <div class="condena-card-content">
        <img src="@/assets/condena_eterna.jpg" alt="Gogo Saporu" class="condena-about-img" />
        <h2 class="condena-text-center">
          Siempre que quieras conocer a Gogo Saporu, debes ser consciente de que este se haya Eternamente Condenado.
        </h2>
        <img src="@/assets/19_sin_titulo_20240129021131.png" alt="Apóstoles" class="condena-about-img" />
        <h2 class="condena-text-center">
          Somos apóstoles, pero no apóstoles, somos discípulos, pero no discípulos, somos creyentes, pero no creyentes, somos traidores, pero no traidores, somos la muerte y las hordas de muerte, nos inclinamos humildemente y pedimos el perdón a nuestro señor entregándonos en reverencia a J, conquistaremos a nuestros enemigos, somos los que baten las dagas en las noches sin lunas, somos los que añaden el veneno a sus cenas, somos lo que acogieron las maneras del padre kotomine, por nuestros pecados, cuando llegue la hora leeremos 30 novelas en el templo y nos uniremos en cuadrillas, mientras nos dirigimos a las profundidades de twitter. Nosotros, seguidores del sudario, en filas de 5 formamos el Agmen Cuadratum deseando ir a la batalla con los 7.405.926 fans de omori en el infierno.
        </h2>
        <h2 class="condena-text-center">Amén!</h2>
        <img src="@/assets/andersen.jpg" alt="Andersen" class="condena-about-img" />
        <a href="https://discord.gg/25GsY2esvV" class="condena-btn">Condénate</a>

        <AdSense />
        <AdSense />
        <AdSense />
        <AdSense />

        <section
          id="biblia-section"
          class="biblia-section"
          :style="{ display: showBiblia ? 'block' : 'none' }"
          ref="bibliaSection"
        >
          <h2>La Biblia de Gogo</h2>
          <button id="close-biblia" class="close-btn" @click="hideBibliaSection">X</button>
          <p>Muchos son los fieles que muestran su fervor por elevar preces a Dios, más empero, en vano será su búsqueda de un sitio terreno en este vasto orbe donde pueda dicha fe, con otros en común, procesarse. Pues para los católicos, la santa iglesia es tenida por la morada de Dios; mas para nosotros, tal edificio no es sino una vana manifestación de la obsesión enfermiza de los hombres por alzarse por encima de su condición mortal y aproximarse a los dioses. Su fe se debilita, ya que, en su soberbia, creen ser el eslabón que se halla justo bajo el trono divino. Mas, en verdad os digo, la fe auténtica en el Altísimo no se halla en ningún templo levantado por manos humanas, ni existe pontífice alguno que encarne su sagrada voluntad. Pues ¿cómo podría la débil mente del hombre comprender lo insondable de los designios de Dios? El verdadero santuario donde se procesa la fe en el Creador yace, únicamente, en el fuero de tu propia voluntad, la cual se revela cuando, tras haber hallado el abismo de la condena eterna, comprendes la esencia de lo divino. Así, aquellos que se congregan en altares erigidos con mármoles y piedras, creyendo que allí habrán de hallar el favor del Altísimo, no hacen sino confundir lo terrenal con lo divino. ¿Acaso creen que la voluntad de Dios puede ser contenida en los muros de una catedral? El hombre, en su vanidad, ha buscado constantemente encerrar el infinito en lo finito, erigiendo santuarios que, a sus ojos, son dignos de albergar lo que no puede ser contenido. Mas, en su ignorancia, olvidan que no es en el oro ni en las estatuas donde reside el espíritu de lo eterno, sino en el mismo corazón del hombre, donde la fe auténtica ha de manifestarse. Los muros de cualquier templo se desplomarán antes de que un hombre encuentre allí la verdad que tanto anhela.</p>
          <p>Aquellos que proclaman ser los emisarios de Dios, vistiendo ornamentos y hablando con palabras de autoridad, no son sino sombras proyectadas por el orgullo del hombre. Se engañan al creer que pueden interpretar los misterios del Creador, como si las palabras que emanan de sus bocas fueran más que el eco de sus propias ambiciones. Pues ¿quién, sino Dios mismo, conoce los secretos de su designio? ¿Quién puede atreverse a pretender que entiende el propósito de lo que es insondable? No hay hombre, ni clérigo ni monarca, que posea la sabiduría para desvelar los hilos que componen el tapiz del cosmos. Y quienes afirman poseer tal poder no hacen sino desviarse, conduciendo a otros al abismo de la ceguera.</p>
          <p>La verdadera comunión con Dios no es algo que pueda ser alcanzado por medio de ritos vacíos ni por la repetición de letanías sin alma. Los hombres repiten palabras que ni entienden ni sienten, creyendo que al hacerlo su salvación está asegurada. Mas no es con palabras huecas como se logra entrar en la gracia de Dios, sino con el alma encendida por la llama de la comprensión. Esa comprensión, sin embargo, no puede ser obtenida sin dolor, sin la lucha constante contra las tinieblas de la ignorancia que habita en el corazón de todo ser humano. Sólo cuando se ha enfrentado al abismo del sufrimiento y se ha abrazado la verdad de la propia fragilidad, puede el hombre comenzar a vislumbrar la luz de lo divino.</p>
          <p>No existe fe verdadera sin duda, pues solo aquel que ha cuestionado la naturaleza de su propia existencia y ha puesto en tela de juicio incluso la existencia de Dios mismo, puede hallar, tras esa búsqueda, una fe que sea sólida. El hombre que nunca ha dudado, nunca ha creído de verdad; su fe es frágil, hecha del material de las ilusiones, fácilmente destruida ante el primer viento de la adversidad. Mas el que ha sufrido y, en su sufrimiento, ha persistido en su búsqueda, ese hallará al final una fe que no puede ser quebrantada. Tal fe no necesita de intermediarios, de sacerdotes ni de instituciones, pues reside en el interior del hombre, indestructible, una vez ha sido forjada en las llamas del sufrimiento y la reflexión.</p>
          <p>Por tanto, os digo: no busquéis a Dios en los edificios ni en las palabras de otros. No pongáis vuestra confianza en aquellos que os prometen la salvación a cambio de obediencia ciega. La senda hacia el Altísimo es solitaria y está llena de espinas, mas es vuestra y solo vuestra. Nadie puede recorrerla por vosotros, ni existen mapas que os guíen. Y al final de esa senda no hay un trono de gloria, como muchos piensan, sino la plena comprensión de la nada que somos, del polvo del que hemos sido hechos. Solo en ese momento, cuando el hombre se despoje de todas sus pretensiones, se postre ante la verdad de su propia insignificancia, podrá encontrar a Dios, no en un lugar o en un objeto, sino en el silencio eterno de su propio ser.</p>
          <div class="biblia-footer">
            <router-link to="/condena/biblia" class="btn-saber-mas">¿Quieres saber más?</router-link>
          </div>
        </section>
      </div>
    </div>
    </div>
  </main>
</template>

<script>
import { ref } from 'vue';
import AdSense from './AdSense.vue';

export default {
  components: {
    AdSense
  },
  name: 'AppCondena',
  setup() {
    const showBiblia = ref(false);
    const bibliaSection = ref(null);

    const showBibliaSection = (event) => {
      event.preventDefault();
      showBiblia.value = true;
      if (bibliaSection.value) {
        bibliaSection.value.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const hideBibliaSection = () => {
      showBiblia.value = false;
    };

    return {
      showBiblia,
      bibliaSection,
      showBibliaSection,
      hideBibliaSection
    };
  }
};
</script>

<style scoped>
/* Aquí van los estilos específicos del componente Condena */
.biblia-footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
}

.btn-saber-mas {
  background-color: #8b4513;
  color: white;
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: bold;
  transition: background-color 0.3s;
  display: inline-block;
}

.btn-saber-mas:hover {
  background-color: #a0522d;
}
</style>